import { Link } from 'react-router-dom';
import { AlertOctagon, AlertTriangle, CheckCircle2, Info } from 'lucide-react';
import { EmptyState } from '../ui/EmptyState';
import type { AttentionItem } from '../../types';

const severityConfig: Record<AttentionItem['severity'], { icon: typeof AlertOctagon; className: string }> = {
  critical: { icon: AlertOctagon, className: 'text-rose-500 bg-rose-50 dark:bg-rose-900/30 dark:text-rose-300' },
  warning: { icon: AlertTriangle, className: 'text-amber-500 bg-amber-50 dark:bg-amber-900/30 dark:text-amber-300' },
  info: { icon: Info, className: 'text-slate-400 bg-slate-100 dark:bg-slate-800 dark:text-slate-400' },
};

export function AttentionFeed({ items }: { items: AttentionItem[] }) {
  if (items.length === 0) {
    return (
      <EmptyState
        icon={CheckCircle2}
        title="Nothing needs attention right now"
        description="All connected systems are reporting healthy."
      />
    );
  }

  return (
    <ul className="divide-y divide-slate-100 dark:divide-slate-800">
      {items.map((item) => {
        const { icon: Icon, className } = severityConfig[item.severity];
        return (
          <li key={item.id}>
            <Link to={item.href} className="flex items-start gap-3 py-3 transition-colors hover:bg-slate-50 dark:hover:bg-slate-800/40 -mx-1 px-1 rounded-lg">
              <div className={`mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-lg ${className}`}>
                <Icon size={14} />
              </div>
              <div className="min-w-0">
                <p className="text-sm font-medium text-slate-800 dark:text-slate-100">{item.title}</p>
                <p className="text-xs text-slate-400">{item.description}</p>
              </div>
            </Link>
          </li>
        );
      })}
    </ul>
  );
}
